var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics"},[_c('v-row',[_c('v-col',[_c('approvals-by-month-panel')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }